module.exports = __webpack_public_path__ + "static/media/page_18.598be48b.jpg";